import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgNudgeFastTruck = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.25 4A.75.75 0 0 1 2 3.25h11.35a.75.75 0 0 1 .75.75v2.25h1.671c1.883 0 2.979 1.797 2.979 3.563V15a.75.75 0 0 1-.75.75h-1.595a3.001 3.001 0 0 1-5.81 0h-2.19a3.001 3.001 0 0 1-5.843-.141.749.749 0 0 1 0-1.218 3.001 3.001 0 0 1 5.843-.141h2.19a3.006 3.006 0 0 1 2.005-2.113V4.75H2A.75.75 0 0 1 1.25 4Zm4.25 9.5a1.5 1.5 0 1 1 .001 2.999A1.5 1.5 0 0 1 5.5 13.5Zm7.1.3A1.507 1.507 0 0 0 12 15a1.5 1.5 0 1 0 .6-1.2Zm3.806.45a3.005 3.005 0 0 0-2.156-2.155V7.75h1.521c.718 0 1.479.744 1.479 2.063v4.437h-.845Z"
    />
    <path d="M.25 7A.75.75 0 0 1 1 6.25h3a.75.75 0 0 1 0 1.5H1A.75.75 0 0 1 .25 7ZM1.25 10A.75.75 0 0 1 2 9.25h2.5a.75.75 0 0 1 0 1.5H2a.75.75 0 0 1-.75-.75Z" />
  </svg>
);
export default SvgNudgeFastTruck;
